import * as React from 'react'
import type { LocationViewType } from '../components/types'
import { DEFAULT_LOCATION_GROUP_BY } from '../components/constants'

export function useLocationFilters() {
  const [originEnabled, setOriginEnabled] = React.useState(false)
  const [destinationEnabled, setDestinationEnabled] = React.useState(false)
  const [originGroupBy, setOriginGroupBy] = React.useState<LocationViewType>(DEFAULT_LOCATION_GROUP_BY)
  const [destinationGroupBy, setDestinationGroupBy] = React.useState<LocationViewType>(DEFAULT_LOCATION_GROUP_BY)

  function detectGroupingLevel(filters: any): LocationViewType {
    if (!filters) return 'Region'

    const hasStateSelections =
      (filters.site_states && filters.site_states.length > 0) ||
      (filters.terminal_states && filters.terminal_states.length > 0)

    if (hasStateSelections) {
      return 'State'
    }

    const hasRegionSelections =
      (filters.site_regions && filters.site_regions.length > 0) ||
      (filters.terminal_regions && filters.terminal_regions.length > 0)

    if (hasRegionSelections) {
      return 'Region'
    }

    return 'Region'
  }

  return {
    originEnabled,
    setOriginEnabled,
    destinationEnabled,
    setDestinationEnabled,
    originGroupBy,
    setOriginGroupBy,
    destinationGroupBy,
    setDestinationGroupBy,
    detectGroupingLevel,
  }
}
